import React, { useState, useEffect, useRef } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { FilterMatchMode } from 'primereact/api';
import { Dialog } from 'primereact/dialog';
import Loader from "../../Shared/Loader/Loader";
import APIConstant from "../../../utils/pathConstants";
import api from "../../../utils/apiClient";
import CommonConfig from '../../../utils/constant';
import AddParentMasterDialog from './AddParentMaster';
import { useNavigate } from 'react-router-dom';
import Toast from '../../Shared/Toast/Toast';
import DeleteConfirmation from '../../Dialogs/DeleteConfirmation';
import ParentCard from './ParentCard';
import { InputSwitch } from 'primereact/inputswitch';
import ResetPassword from '../../ResetPassword/ResetPassword';
import { useCatchResponse } from '../../../utils/useCatchResponse';
import { apiBase } from '../../../utils/config';
import { FileUpload } from "primereact/fileupload";
import { Tooltip } from 'primereact/tooltip';
import { Tag } from 'primereact/tag';
import { Paginator } from 'primereact/paginator';
import { Checkbox } from 'primereact/checkbox';



const ParentMaster = () => {
    const { catchResponse } = useCatchResponse();
    const navigate = useNavigate();
    const [parentList, setParentList] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const [classId, setParentId] = useState('');
    const [visible, setVisible] = useState(false);
    const [viewMode, setViewMode] = useState('card');
    const [deleteType, setDeleteType] = useState('Single');

    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        ParentId: { value: null, matchMode: FilterMatchMode.CONTAINS },
        Name: { value: null, matchMode: FilterMatchMode.CONTAINS },
        Gender: { value: null, matchMode: FilterMatchMode.CONTAINS },
        Phone: { value: null, matchMode: FilterMatchMode.CONTAINS },
        Email: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });
    const [totalRecords, setTotalRecords] = useState(0);
    const [visibleStudentList, setVisibleStudentList] = useState(false);
    const [masterStudentList, setMasterStudentList] = useState([]);
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [securityUserID, setSecurityUserID] = useState("");
    const [rows, setRows] = useState(10);
    const [first, setFirst] = useState(0);
    const [isDeleteConfirmation, setIsDeleteConfirmation] = useState(false);
    const [isStatusConfirmation, setIsStatusConfirmation] = useState(false);
    const [deleteId, setDeleteId] = useState('');
    const [updatedStatus, setUpdatedStatus] = useState('');
    const [updatedPassword, setUpdatedPassword] = useState('');
    const [isPasswordReset, setIsPasswordReset] = useState(false);
    const [accessList, setAccessList] = useState({});
    const [pageAccess, setPageAccess] = useState({});
    const [isUploadVisible, setIsUploadVisible] = useState(false);
    const [loadedPages, setLoadedPages] = useState(1);
    const [selectedParents, setSelectedParents] = useState([]);
    const fileUploadRef = useRef(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                Loader.show();
                const loginData = CommonConfig.loginData();
                const accessData = CommonConfig.getUserAccess('Parent Master');
                setPageAccess(accessData);
                setSecurityUserID(loginData?._id);
                await GetParentList(loginData?._id, loadedPages ?? 1);
                await GetConfigurationData(loginData?._id);
            } catch (error) {
                Loader.hide();
                console.error('Error in useEffect:', error);
            } finally {
                Loader.hide();
            }
        };
        fetchData();
    }, []);

    useEffect(() => {
        if (!Array.isArray(parentList) || !Array.isArray(selectedParents)) return;

        const filtered = parentList?.filter(x => {
            if (!globalFilterValue) return true;
            const q = globalFilterValue.toLowerCase();
            return (x?.Name?.toLowerCase()?.includes(q) ||
                x?.ParentId?.toLowerCase()?.includes(q) ||
                x?.Gender?.toLowerCase()?.includes(q) ||
                x?.Email?.toLowerCase()?.includes(q) ||
                x?.Phone?.includes(q));
        });

        const allSelected = filtered?.length > 0 &&
            filtered?.every(s => selectedParents?.some(sel => sel?._id === s?._id));

        setSelectAll(allSelected);
    }, [selectedParents, parentList, globalFilterValue]);

    const GetConfigurationData = async (id) => {
        try {
            let data = {
                id: id,
            }
            await api.post(APIConstant.path.GetPasswordConfigurationDetail, data).then(async response => {
                let res = response;
                if (res.success) {
                    setAccessList(res?.data);
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };
        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const onPageChange = async (e) => {
        setFirst(e.first);
        setRows(e.rows);

        const endIndex = e.first + e.rows;
        const alreadyLoaded = loadedPages * 50;
        if (endIndex > alreadyLoaded && alreadyLoaded < totalRecords) {
            await GetParentList(securityUserID, loadedPages + 1)
        }
    };

    const GetParentList = async (id, pageno) => {
        try {
            let data = {
                UserID: id,
                page: pageno,
                limit: 50,
            }
            await api.post(APIConstant.path.getParentDetailList, data).then(async response => {
                let res = response;
                if (res.success) {
                    if (pageno === 1) {
                        setParentList(res?.data);
                    } else {
                        setParentList(prev => [...prev, ...res?.data]);
                    }

                    setTotalRecords(res?.totalRecord);
                    setLoadedPages(pageno);
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const actionBodyTemplate = (rows) => {
        return (
            <React.Fragment>
                <div className='p-d-flex p-ai-center'>
                    {pageAccess?.ViewAccess &&
                        <Button icon="icon-view tailer-icon" className="e-sction-btn" onClick={() => navigate('/viewEdit-parent-master', { state: { userId: rows?._id, isEdit: false } })} />}
                    {pageAccess?.EditAccess &&
                        <Button icon="pi pi-pencil" className="e-sction-btn p-mx-2" onClick={() => navigate('/viewEdit-parent-master', { state: { userId: rows?._id, isEdit: true } })} />}
                    {pageAccess?.DeleteAccess &&
                        <Button icon="pi pi-trash" className="e-sction-btn" onClick={(e) => {
                            setIsDeleteConfirmation(true);
                            setDeleteId(rows._id);
                        }} />}
                    {pageAccess?.EditAccess && (
                        <>
                            <InputSwitch
                                checked={rows?.Status === 'Active' ? true : false}
                                onChange={(e) => {
                                    toggleActiveStatus(rows._id, e.value);
                                }}
                                className="p-ml-2 p-mt-1"
                            />
                            {rows?.Phone && accessList?.IsParent &&
                                <Button icon="pi pi-key" className="e-sction-btn p-m-0 p-m-2" onClick={(e) => {
                                    setIsPasswordReset(true);
                                    setDeleteId(rows._id);
                                }} />}
                        </>)}
                </div>
            </React.Fragment>
        );
    };

    const handleResetClose = () => {
        setIsPasswordReset(false)
    };

    const UpdateStatus = async () => {
        try {
            let data = {
                id: deleteId,
                Status: updatedStatus
            }
            await api.post(APIConstant.path.updateParentStatus, data).then(async response => {
                let res = response;
                if (res.success) {
                    Loader.hide();
                    Toast.success({ message: 'Parent status updated successfully' });
                    setDeleteId('');
                    setUpdatedStatus('');
                    GetParentList(securityUserID, loadedPages);
                }
                handleCloseStatus();
            }).catch(err => {
                Loader.hide();
                setDeleteId('');
                setUpdatedStatus('');
                handleCloseStatus();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const handleResetPassword = (id) => {
        setIsPasswordReset(true);
        setDeleteId(id);
    };

    const renderResetFooter = () => (
        <div className="dialog-footer p-d-flex p-ai-center p-jc-end">
            <Button
                label="Cancel"
                className="btn-text-action-secondary"
                onClick={handleResetClose}
            />
            <Button
                label="Save"
                className="btn-text-action-primary"
                onClick={(e) => UpdatePassword()}
            />
        </div>
    );

    const handlePasswordChange = (password) => {
        setUpdatedPassword(password);
    };

    const UpdatePassword = async () => {
        try {
            let data = {
                id: deleteId,
                Password: updatedPassword
            }
            await api.post(APIConstant.path.updatePassword, data).then(async response => {
                let res = response;
                if (res.success) {
                    Loader.hide();
                    Toast.success({ message: 'Parent password updated successfully' });
                    setDeleteId('');
                    setUpdatedPassword('');
                    await GetParentList(securityUserID, loadedPages);
                }
                handleResetClose();
            }).catch(err => {
                Loader.hide();
                Toast.error({ message: err?.message });
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const DeleteParent = async () => {
        try {
            let data;
            if (deleteType == 'Single') {
                data = {
                    id: deleteId
                };
            } else {
                const deletedID = selectedParents?.map((y) => y?._id);
                data = {
                    ids: deletedID
                }
            }
            await api.post(APIConstant.path.deleteParent, data).then(async response => {
                let res = response;
                if (res.success) {
                    Loader.hide();
                    Toast.success({ message: 'Parent deleted successfully' });
                    setDeleteId('');
                    setUpdatedStatus('');
                    GetParentList(securityUserID, loadedPages);
                }
                handleClose();
            }).catch(err => {
                Loader.hide();
                setDeleteId('');
                setUpdatedStatus('');
                handleClose();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const toggleActiveStatus = (id, status) => {
        setDeleteId(id);
        setUpdatedStatus(status === true ? 'Active' : 'Inactive');
        setIsStatusConfirmation(true);
    };

    const renderFooter = () => (
        <div className="dialog-footer p-d-flex p-ai-center p-jc-end">
            <Button
                label="Cancel"
                className="btn-text-action-secondary"
                onClick={handleClose}
            />
            <Button
                label="Delete"
                className="btn-text-action-primary"
                onClick={(e) => DeleteParent()}
            />
        </div>
    );

    const handleClose = () => {
        setIsDeleteConfirmation(false)
    };

    const handleDelete = (id) => {
        setIsDeleteConfirmation(true);
        setDeleteId(id);
    };

    const renderStatusFooter = () => (
        <div className="dialog-footer p-d-flex p-ai-center p-jc-end">
            <Button
                label="Cancel"
                className="btn-text-action-secondary"
                onClick={handleCloseStatus}
            />
            <Button
                label="Save"
                className="btn-text-action-primary"
                onClick={(e) => UpdateStatus()}
            />
        </div>
    );

    const handleCloseStatus = () => {
        setIsStatusConfirmation(false)
    };

    const onCancel = () => {
        setVisible(false);
        setParentId('');
        GetParentList(securityUserID, loadedPages);
    }

    const actionBodyTemplateSrNo = (data, props) => {
        return props.rowIndex + 1;
    };

    const countBodyTemplateSrNo = (data, props) => {
        return <div onClick={() => {
            setVisibleStudentList(true);
            setMasterStudentList(data?.ChildrensList)
        }}>{data?.ChildrenCount}</div>
    };

    const handleUploadVisible = () => {
        setIsUploadVisible(false)
    };

    const headerTemplate = (options) => {
        const { className, chooseButton, uploadButton, cancelButton } = options;
        return (
            <div className={className} style={{ backgroundColor: 'transparent', display: 'flex', alignItems: 'center' }}>
                {chooseButton}
                {uploadButton}
                {cancelButton}
            </div>
        );
    };

    const onTemplateRemove = (file, callback) => {
        callback();
    };

    const itemTemplate = (file, props) => {
        return (
            <div className="">
                <div className="p-d-flex p-ai-baseline p-jc-between">
                    <div className="flex flex-column text-left ml-3">
                        <p> {file.name} </p>
                        <small>{new Date().toLocaleDateString()}</small>
                    </div>
                </div>
                <Tag value={props.formatSize} severity="warning" className="e-uplod-box" />
                <div className='p-d-flex p-ai-center p-jc-center'>
                    <Button type="button" icon="pi pi-times" className="p-d-flex p-ai-center p-jc-center p-button-outlined p-button-rounded p-button-danger ml-auto p-m-0" onClick={() => onTemplateRemove(file, props.onRemove)} />
                </div>
            </div>
        );
    };

    const emptyTemplate = () => {
        return (
            <div className="flex align-items-center flex-column">
                <i className="pi pi-image mt-3 p-5" style={{ fontSize: '5em', borderRadius: '50%', backgroundColor: 'var(--surface-b)', color: 'var(--surface-d)' }}></i>
                <span style={{ fontSize: '1.2em', color: 'var(--text-color-secondary)' }} className="my-5">
                    Drag and Drop Image Here
                </span>
            </div>
        );
    };

    const handleDownloadSampleFile = async () => {
        try {
            Loader.show();
            const loginData = CommonConfig.loginData();
            const payload = {
                accountType: loginData?.AccountType,
                userType: loginData?.UserType,
                userId: securityUserID,
            };
            const res = await api.post(APIConstant.path.GenerateParentSample, payload);
            if (res.success && res?.sampleFileUrl) {
                const downloadUrl = `${apiBase}${res.sampleFileUrl}`;
                const link = document.createElement("a");
                link.href = downloadUrl;
                link.setAttribute("download", downloadUrl.split('/').pop());
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                Loader.hide();
            } else {
                Loader.hide();
                Toast.error({ message: res?.message || 'Failed to download sample file' });
            }
        } catch (err) {
            Loader.hide();
            Toast.error({ message: err?.message || 'Failed to download sample file' });
            catchResponse(err);
        }
    };

    const onTemplateUpload = async (e) => {
        const uploadedFile = e.files[0];
        if (!uploadedFile) return;

        try {
            Loader.show();
            const loginData = CommonConfig.loginData();
            const formData = new FormData();
            formData.append("file", uploadedFile);
            formData.append("filename", uploadedFile?.name);
            formData.append("accountType", loginData?.AccountType);
            formData.append("userType", loginData?.UserType);
            formData.append("userId", securityUserID);
            await api.post(APIConstant.path.ImportParents, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }).then(async (response) => {
                let res = response;
                if (res.success) {
                    Loader.hide();
                    Toast.success({ message: res?.message });
                    if (res?.skippedFileUrl) {
                        var downloadUrl = `${apiBase}${res?.skippedFileUrl}`;
                        const link = document.createElement("a");
                        link.href = downloadUrl;
                        link.setAttribute("download", downloadUrl.split('/').pop());
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    }
                    handleUploadVisible();
                    await GetParentList(securityUserID, loadedPages);
                } else {
                    Loader.hide();
                    Toast.error({ message: res.message });
                    if (res?.skippedFileUrl) {
                        var downloadcatchUrl = `${apiBase}${res?.skippedFileUrl}`;
                        const link = document.createElement("a");
                        link.href = downloadcatchUrl;
                        link.setAttribute("download", downloadcatchUrl.split('/').pop());
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    }
                }
            })
                .catch((err) => {
                    console.error(err);
                    Toast.error({ message: err?.message });
                    Loader.hide();
                });

        } catch (error) {
            Loader.hide();
            const errorMessage = error.response?.data?.message || "File upload failed.";
            Toast.error({ message: errorMessage });
            catchResponse(error);
        }
    };

    const handleSelectParent = (parent) => {
        setSelectedParents((prev) => {
            const exists = prev?.some(s => s?._id === parent?._id);
            if (exists) {
                return prev?.filter(s => s?._id !== parent?._id);
            } else {
                return [...prev, parent];
            }
        });
    };

    const chooseOptions = { icon: 'pi pi-fw pi-images', iconOnly: true, className: 'p-d-flex p-ai-center p-jc-center p-button-rounded p-button-outlined p-m-0' };
    const uploadOptions = { icon: 'pi pi-fw pi-cloud-upload', iconOnly: true, className: 'p-d-flex p-ai-center p-jc-center p-button-success p-button-rounded p-button-outlined p-m-0' };
    const cancelOptions = { icon: 'pi pi-fw pi-times', iconOnly: true, className: 'p-d-flex p-ai-center p-jc-center p-button-danger p-button-rounded p-button-outlined p-m-0' };


    return (
        <div className='wayment-owner-dashboard et-master-page'>
            <div className="heading-area p-d-flex p-ai-center p-jc-between">
                <div className="p-d-flex p-ai-baseline">
                    <i className="pi pi-user"></i>
                    <h2>Parent Master</h2>
                </div>
                <div className="p-d-flex p-ai-center p-jc-between">
                    <div className="searchbar-area e-searchbar-area">
                        <i className="pi pi-search" />
                        <InputText
                            value={globalFilterValue}
                            onChange={onGlobalFilterChange}
                            placeholder="Global Search"
                        />
                    </div>
                    {pageAccess?.DeleteAccess && <Checkbox inputId="selectAll" className='p-mr-2' checked={selectAll} onChange={(e) => {
                        setSelectAll(e.checked);
                        if (e.checked) {
                            const filtered = parentList?.filter(x => {
                                if (!globalFilterValue) return true;
                                const q = globalFilterValue.toLowerCase();
                                return (x?.Name?.toLowerCase()?.includes(q) ||
                                    x?.ParentId?.toLowerCase()?.includes(q) ||
                                    x?.Gender?.toLowerCase()?.includes(q) ||
                                    x?.Email?.toLowerCase()?.includes(q) ||
                                    x?.Phone?.includes(q));
                            });
                            setSelectedParents(filtered);
                        } else {
                            setSelectedParents([]);
                        }
                    }} />}
                    {pageAccess?.AddAccess &&
                        <Button icon="pi pi-plus" className="e-h-btn" onClick={() => setVisible(true)} />}
                    <Button
                        icon={viewMode === 'card' ? 'pi pi-bars' : 'pi pi-th-large'}
                        className="e-h-btn p-ml-2"
                        onClick={() => setViewMode(viewMode === 'card' ? 'list' : 'card')}
                    />
                    {pageAccess?.AddAccess && (
                        <>
                            <Button icon="pi pi-upload" onClick={(e) => setIsUploadVisible(true)} className="e-h-btn p-ml-2" />
                            <Button icon="pi pi-download" onClick={handleDownloadSampleFile} className="e-h-btn p-ml-2" />
                        </>)}
                    {pageAccess?.DeleteAccess && selectedParents.length > 0 &&
                        <Button
                            icon={'pi pi-trash'}
                            className="e-h-btn p-ml-2"
                            onClick={() => {
                                setDeleteType('Multi');
                                handleDelete('');
                            }}
                        />}
                </div>
            </div>
            {viewMode === 'card' ? (
                <div className='e-student-master-table error-page-body'>
                    <div className='teacher-grid'>
                        {parentList?.filter(x => {
                            if (!globalFilterValue) return true;
                            const q = globalFilterValue.toLowerCase();
                            return (x?.Name?.toLowerCase()?.includes(q) ||
                                x?.ParentId?.toLowerCase()?.includes(q) ||
                                x?.Gender?.toLowerCase()?.includes(q) ||
                                x?.Email?.toLowerCase()?.includes(q) ||
                                x?.Phone?.includes(q));
                        })?.slice(first, first + rows)?.map(parent => (
                            <ParentCard
                                key={parent._id}
                                parent={parent}
                                handleDelete={handleDelete}
                                toggleActiveStatus={toggleActiveStatus}
                                handlePassword={handleResetPassword}
                                AccessList={accessList}
                                pageAccess={pageAccess}
                                selectedParents={selectedParents}
                                onSelectParent={handleSelectParent}
                            />
                        ))}
                    </div>
                    <div>
                        <Paginator
                            first={first}
                            rows={rows}
                            totalRecords={totalRecords}
                            rowsPerPageOptions={[5, 10, 20]}
                            onPageChange={onPageChange}
                            template="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                            currentPageReportTemplate="Showing {first}-{last} of {totalRecords} records"
                        />
                    </div>
                </div>
            ) : (
                <DataTable
                    value={parentList}
                    selection={selectedParents}
                    onSelectionChange={(e) => setSelectedParents(e.value)}
                    dataKey="_id"
                    selectionMode="multiple"
                    paginator
                    rows={rows}
                    first={first}
                    totalRecords={totalRecords}
                    filters={filters}
                    filterDisplay="menu"
                    globalFilterFields={['ParentId', 'Name', 'Gender', 'Phone', 'Email']}
                    responsiveLayout="scroll"
                    paginatorTemplate="RowsPerPageDropdown CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink JumpToPageInput"
                    rowsPerPageOptions={[5, 10, 20]}
                    currentPageReportTemplate="Showing {first}-{last} of {totalRecords} records"
                    onPage={onPageChange}
                    className='custom-table'
                    scrollHeight='calc(1200vh - 60px)'
                    size='small'
                >
                    <Column selectionMode="multiple" headerStyle={{ width: '3em' }} />
                    <Column field="id" body={actionBodyTemplateSrNo} header="Sr No." style={{ width: '10%' }} />
                    <Column
                        field="ParentId"
                        header="Parent ID"
                        style={{ width: '20%' }}
                    />
                    <Column
                        field="Name"
                        header="Name"
                        style={{ width: '20%' }}
                    />
                    <Column
                        field="Gender"
                        header="Gender"
                        style={{ width: '10%' }}
                    />
                    <Column
                        body={countBodyTemplateSrNo}
                        header="Childrens"
                        style={{ width: '10%' }}
                    />
                    <Column
                        field="Phone"
                        header="Contact No."
                        style={{ width: '20%' }}
                    />
                    <Column
                        field="Email"
                        header="Email ID"
                        style={{ width: '20%' }}
                    />
                    <Column body={actionBodyTemplate} header="Action" headerClassName='e-template-action' bodyClassName='e-template-action' headerStyle={{ width: '100%' }} />
                </DataTable>
            )}
            <Dialog
                header={classId ? "Edit Parent Master" : "Add Parent Master"}
                className='dialog-popup'
                visible={visible}
                onHide={() => onCancel()}
                draggable={false}
                position="center"
                style={{ width: '50vw' }}
            >
                <AddParentMasterDialog onCancel={onCancel} />

            </Dialog>
            <Dialog
                visible={isPasswordReset}
                onHide={handleResetClose}
                header={
                    <div className="p-d-flex p-jc-between p-ai-center">
                        <span>Reset Password</span>
                    </div>
                }
                footer={renderResetFooter()}
                draggable={false}
                dismissableMask
                position="center"
                style={{ width: '450px' }}
            >
                <ResetPassword onPasswordChange={handlePasswordChange} />
            </Dialog>
            <Dialog
                header="Childreen List"
                visible={visibleStudentList}
                onHide={() => {
                    setVisibleStudentList(false)
                    setMasterStudentList([]);
                }}
                draggable={false}
                position="center">

                <div className="p-col-12 p-card p-p-3">
                    <DataTable value={masterStudentList} paginatorTemplate="RowsPerPageDropdown CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink JumpToPageInput"
                        currentPageReportTemplate="Showing {first}-{last} of {totalRecords} records" rowsPerPageOptions={[10, 20, 50]} className='custom-table'
                        scrollHeight='calc(100vh - 120px)'
                        size='small'>
                        <Column body={actionBodyTemplateSrNo} header="Sr No." />
                        <Column field="Name" header="Childreen Name" />
                        <Column field="Email" header="Email" />
                        <Column field="Phone" header="Phone" />
                    </DataTable>
                </div>
            </Dialog>

            <Dialog
                visible={isDeleteConfirmation}
                onHide={handleClose}
                header={
                    <div className="p-d-flex p-jc-between p-ai-center">
                        <span>Delete Confirmation</span>
                    </div>
                }
                footer={renderFooter()}
                draggable={false}
                dismissableMask
                position="center"
                style={{ width: '450px' }}
            >
                <DeleteConfirmation />
            </Dialog>
            <Dialog
                visible={isUploadVisible}
                onHide={handleUploadVisible}
                header="Upload Excel"
                draggable={false}
                dismissableMask
                position="center"
                style={{ width: '500px', minHeight: '480px', maxHeight: '480px', }}
            >
                <div>
                    <div className='p-d-fle p-ai-center p-jc-between p-w-100'>
                        <div>
                            <Tooltip className='p-m-0' target=".custom-choose-btn" content="Choose" position="bottom" />
                        </div>
                        <div>
                            <Tooltip className='p-m-0' target=".custom-upload-btn" content="Upload" position="bottom" />
                        </div>
                        <div>
                            <Tooltip className='p-m-0' target=".custom-cancel-btn" content="Clear" position="bottom" />
                        </div>
                        <FileUpload ref={fileUploadRef} name="file" accept=".xlsx" multiple={false} customUpload={true} uploadHandler={onTemplateUpload} headerTemplate={headerTemplate} itemTemplate={itemTemplate} emptyTemplate={emptyTemplate} chooseOptions={chooseOptions} uploadOptions={uploadOptions} cancelOptions={cancelOptions} />
                    </div>
                </div>
            </Dialog>
            <Dialog
                visible={isStatusConfirmation}
                onHide={handleCloseStatus}
                header={
                    <div className="p-d-flex p-jc-between p-ai-center">
                        <span>Status Update</span>
                    </div>
                }
                footer={renderStatusFooter()}
                draggable={false}
                dismissableMask
                position="center"
                style={{ width: '450px' }}
            >
                <div>
                    <p>
                        Are you sure you want to update status?
                    </p>
                </div>
            </Dialog>
        </div>
    );
};

export default ParentMaster;
